export const getPhoneHref = (value = "") => {
  const match = String(value).match(/(\+?\d[\d\s().-]{6,}\d)/);
  if (!match) return "";
  return `tel:${match[1].replace(/[^\d+]/g, "")}`;
};
